"use strict";
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CombinedSessionItem = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("../constants");
var _tokens = require("../tokens");
var _SessionStorage = require("./SessionStorage");
var CombinedSessionItem = /*#__PURE__*/ function() {
    function CombinedSessionItem() {
        _class_call_check(this, CombinedSessionItem);
        (0, _defineProperty2.default)(this, "storage", new _SessionStorage.SessionStorage());
    }
    _create_class(CombinedSessionItem, [
        {
            key: "remove",
            value: function remove() {
                this.storage.removeItem(_constants.USER_TOKEN_STORAGE_KEY);
                this.storage.removeItem(_constants.ANONYMOUS_TOKEN_STORAGE_KEY);
                return this;
            }
        },
        {
            key: "get",
            value: function get() {
                var userToken = this.storage.getItem(_constants.USER_TOKEN_STORAGE_KEY);
                var anonymousToken = this.storage.getItem(_constants.ANONYMOUS_TOKEN_STORAGE_KEY);
                // If user token is present then user was probably logged in already
                if (userToken) {
                    return userToken;
                }
                if (anonymousToken) {
                    return anonymousToken;
                }
                return null;
            }
        },
        {
            key: "set",
            value: function set(value) {
                this.remove();
                var parsedToken = new _tokens.OidcToken(value.Token);
                var customerId = parsedToken.getClaim('customer_id');
                var isUserSignedIn = typeof customerId === 'number' && customerId > 0;
                var key = isUserSignedIn ? _constants.USER_TOKEN_STORAGE_KEY : _constants.ANONYMOUS_TOKEN_STORAGE_KEY;
                this.storage.setItem(key, value);
                return this;
            }
        }
    ]);
    return CombinedSessionItem;
}();
exports.CombinedSessionItem = CombinedSessionItem; //# sourceMappingURL=CombinedSessionItem.js.map
